import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentMethod } from '../../core/reducers/financialCalculators';
import Loader from '../../utils/components/Loader';
import Error from '../PriceComponent/Error';
import CashPanel from './CashPanel';
import FinanceAndLeasePanel from './FinanceAndLeasePanel';
const errorComponentStyles = { container: { marginTop: '16px' }, copy: { size: 'extraSmall' } };
const isPaymentValid = (payment, paymentMethod) => {
    if (!payment)
        return false;
    const { apr, term, preferredPaymentAmount, msrp, sellingPrice } = payment;
    switch (paymentMethod) {
        case PaymentMethod.finance:
        case PaymentMethod.lease:
            return !!(apr && term && preferredPaymentAmount);
        case PaymentMethod.cash:
            return !!(msrp.value && sellingPrice.value);
        default:
            return false;
    }
};
const PaymentDetails = ({ paymentFrequency, paymentMethod, payment, isFetching, error, modelYear, overriddenIsSellingProvince, includeFees, disableMsrp, }) => {
    const { t } = useTranslation();
    if (!isFetching && (error || !isPaymentValid(payment, paymentMethod))) {
        return (React.createElement(Error, { message: t('Pages.Models.Exploration.contactLocalDealerLabel'), horizontalAlignment: "center", verticalAlignment: "center", errorStyles: errorComponentStyles, errorIconName: "exclamationAlert" }));
    }
    if (isFetching) {
        return React.createElement(Loader, { testId: "cy-loading-state", horizontalAlignment: "center", isLargeIcon: true, loadingIconHeight: "28px" });
    }
    switch (paymentMethod) {
        case PaymentMethod.finance:
        case PaymentMethod.lease:
            return (React.createElement(FinanceAndLeasePanel, { payment: payment, paymentFrequency: paymentFrequency, paymentMethod: paymentMethod, modelYear: modelYear, overriddenIsSellingProvince: overriddenIsSellingProvince }));
        case PaymentMethod.cash:
            return (React.createElement(CashPanel, { payment: payment, error: error, isFetching: isFetching, includeFees: includeFees, overriddenIsSellingProvince: overriddenIsSellingProvince, disableMsrp: disableMsrp }));
        default:
            return null;
    }
};
export default PaymentDetails;
